import {Button} from '@/components/common-components/v2';
import {useStore} from '@/store/root-store';
import {faArrowRight, faBolt} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import React from 'react';

interface Props {
  isInTable?: boolean;
  isPublicPage?: boolean;
}

export const PublicPageBanner:React.FC<Props> = observer(({isInTable=false, isPublicPage=false}) => {
  const {settings: {customer: {setAuthModal}}} = useStore('');
  return (<Container isInTable={isInTable} isPublicPage={isPublicPage}>
    <div>
      <IconContainer isInTable={isInTable}>
        <FontAwesomeIcon icon={faBolt} color={isInTable ? '#1FAC47' : '#121212'}/>
      </IconContainer>
      <div>
        <Heading>Get a 7 Day trial for Free to see more</Heading>
        <SubHeading>Please upgrade your subscription to expand your possibilities.</SubHeading>
      </div>
    </div>
    <Button color={isInTable ? 'green' : 'black'} onClick={() => setAuthModal(true, false)}>7 Day Free Trial&nbsp;<FontAwesomeIcon icon={faArrowRight}/></Button>
  </Container>);
});


const Container = styled.div<{isInTable: boolean; isPublicPage: boolean}>`
  width: ${p=> p?.isPublicPage ? '100%' : '100%'};
  height: 90px;
  margin-top: ${p => p.isInTable ? '0' : '10px'};
  background: ${p => p.isInTable ? '#fff' : '#FFB94E'};
  ${p => p?.isInTable && `border: 1px solid #E8E8E8;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25);`}
    margin-left: ${p=> p?.isPublicPage ? '0px' : '0px'};
  border-radius: 20px;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  > div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

const IconContainer = styled.div<{isInTable: boolean}>`
  width: 46px;
  height: 46px;
  background: ${p => p.isInTable ? '#1FAC4726' : '#12121226'};
  font-size: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Heading = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #121212;
`;

const SubHeading = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #121212;
  margin-top: 4px;
`;
